import React, { useEffect, useState } from 'react';
import {
  ActionIcon, Button, Center, Modal, Skeleton, Pagination, Text,
} from '@mantine/core';
import UniversalTable from '../Common/UniversalTable';
import { Refresh } from 'tabler-icons-react';
import { showNotification } from '@mantine/notifications';
// import smartTruncate from 'smart-truncate';
import { formatDate, loadingStates } from '../../utilities/utilities';
// import UserAvatarView from '../UserAvatarView';
import { apiWrapWithErrorWithData } from '../../utilities/apiHelpers';
import { listCaseRecords } from '../../utilities/apis/cases';
import CaseRecordForm from '../CaseRecordForm/CaseRecordForm';
import CaseRecordDetail from '../CaseRecordDetail/CaseRecordDetail';
import CaseRecordSummary from './CaseRecordSummary';
import CaseRecordFile from './CaseRecordFile';

const CaseRecordTab = ({ parent, parentId, title }) => {
  const [caseRecordsConfig, setCaseRecordsConfig] = useState({
    caseRecordFormVisible: false,
    loading: loadingStates.NO_ACTIVE_REQUEST,
    caseRecords: [],
    page: 1,
    caseRecordsCount: null,
    loadCaseRecord: null,
  });

  const getRecords = async () => {
    setCaseRecordsConfig((caseRecordC) => ({
      ...caseRecordC,
      loading: loadingStates.LOADING,
      caseRecordsCount: null,
    }));
    const response = await apiWrapWithErrorWithData(
      listCaseRecords({
        caseId: parentId,
        page: caseRecordsConfig.page,
      }),
    );
    if (response?.success && response?.caseRecords) {
      setCaseRecordsConfig({
        ...caseRecordsConfig,
        caseRecords: response.caseRecords,
        loading: loadingStates.NO_ACTIVE_REQUEST,
        caseRecordsCount: response.caseRecordsCount || null,
      });
    } else {
      // showNotification({
      //   color: 'red',
      //   title: 'Case records',
      //   message: `Failed to load records for ${parent} ${parentId}`,
      // });
      setCaseRecordsConfig({
        ...caseRecordsConfig,
        loading: loadingStates.NO_ACTIVE_REQUEST,
      });
    }
  };
  useEffect(() => {
    if (caseRecordsConfig.loadCaseRecord === null || !caseRecordsConfig.caseRecordFormVisible) {
      getRecords();
    }
  }, [caseRecordsConfig.loadTask, caseRecordsConfig.caseRecordFormVisible]);

  const caseRecordTableHeaders = [
    { label: 'Date of Hearing', key: 'caseDate', render: (row) => <Text size="sm">{formatDate(row.caseDate)}</Text> },
    { label: 'Purpose', key: 'purpose' },
    { label: 'Next Date of Hearing', key: 'nextHearing', render: (row) => <Text size="sm">{formatDate(row.nextHearing)}</Text> },
    { label: 'Fixed for', key: 'fixedFor' },
    { label: 'Summary', key: 'summary', render: (row) => <CaseRecordSummary id={row.id} /> },
    { label: 'Order', key: 'order', render: (row) => <CaseRecordFile id={row.id} /> },
  ];

  return (
    <>
      {caseRecordsConfig.caseRecordFormVisible
                && (
                <Modal
                  closeOnClickOutside={false}
                  overflow="inside"
                  opened
                  onClose={() => {
                    setCaseRecordsConfig({
                      ...caseRecordsConfig,
                      caseRecordFormVisible: false,
                    });
                  }}
                  size="calc(80vw)"
                >
                  <CaseRecordForm
                    parent={parent}
                    parentId={parentId}
                    title={title}
                    onModalExit={() => {
                      setCaseRecordsConfig({
                        ...caseRecordsConfig,
                        caseRecordFormVisible: false,
                      });
                    }}
                  />
                </Modal>
                )}

      {(caseRecordsConfig.loadCaseRecord !== null)
                && (
                <Modal
                  overflow="inside"
                  opened
                  onClose={() => {
                    setCaseRecordsConfig({
                      ...caseRecordsConfig,
                      loadCaseRecord: null,
                    });
                  }}
                  size="calc(80vw)"
                >
                  <CaseRecordDetail
                    parent={parent}
                    parentId={parentId}
                    title={title}
                    recordId={caseRecordsConfig.loadCaseRecord}
                    onModalExit={() => {
                      setCaseRecordsConfig({
                        ...caseRecordsConfig,
                        loadCaseRecord: null,
                      });
                    }}
                  />
                </Modal>
                )}
      <div className="flex flex-col p-4">
        <div className="flex flex-row justify-end">
          <div className="flex items-center">
            <ActionIcon color="white" className="mx-2" onClick={getRecords}>
              <Refresh />
            </ActionIcon>
            <Button
              onClick={() => setCaseRecordsConfig({
                ...caseRecordsConfig,
                caseRecordFormVisible: true,
              })}
              className="w-40 mx-2"
            >
              Create Record
            </Button>
          </div>
        </div>
        {caseRecordsConfig.loading === loadingStates.LOADING
                    && (
                    <div className="flex flex-col mb-2">
                      <Skeleton height={30} radius="md" className="my-1 w-full" />
                      <Skeleton height={30} radius="md" className="my-1 w-full" />
                      <Skeleton height={30} radius="md" className="my-1 w-full" />
                      <Skeleton height={30} radius="md" className="my-1 w-full" />
                      <Skeleton height={30} radius="md" className="my-1 w-full" />
                      <Skeleton height={30} radius="md" className="my-1 w-full" />
                      <Skeleton height={30} radius="md" className="my-1 w-full" />
                      <div className="flex flex-row justify-center">
                        <Skeleton height={40} radius="md" className="w-40" />
                      </div>
                    </div>
                    )}
        {((caseRecordsConfig.loading !== loadingStates.LOADING
                && !caseRecordsConfig.caseRecords?.length))
                    && <Center className="my-4">No case records to show</Center>}
        {(caseRecordsConfig.loading !== loadingStates.LOADING
            && !!caseRecordsConfig.caseRecords.length) && (
            <UniversalTable
              headers={caseRecordTableHeaders}
              data={caseRecordsConfig.caseRecords}
              loading={false}
              emptyMessage="No case records to show"
            />
        )}
        {caseRecordsConfig.caseRecordsCount
                    && (
                    <div className="flex justify-center mt-4">
                      <Pagination
                        onChange={(page) => {
                          setCaseRecordsConfig({
                            ...caseRecordsConfig,
                            page,
                          });
                        }}
                        total={Math.ceil(caseRecordsConfig.caseRecordsCount / 5)}
                        page={caseRecordsConfig.page}
                      />
                    </div>
                    )}
      </div>
    </>
  );
};

export default CaseRecordTab;
